import React from 'react';

const ThankYouFR = () => (
  <div className="bussiness-contact-form">
    <div className="container">
      <div className="row">
        <div className="col-md-12" style={{ border: '#bbb solid 1px', paddingTop: '25px' }}>
          <div className="business-title-left">
            <h2>
              <span role="img" aria-label="Envelope">
                📩 📩{' '}
              </span>Message reçu ! Nous vous en remercions !
            </h2>
            <span className="title-border-left" />
            <br />
            <h3>Nous répondrons le plus rapidement possible !</h3>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default ThankYouFR;



// WEBPACK FOOTER //
// ./src/components/ThankYouFR.js